import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalShellComponent } from '../ui/modal-shell/modal-shell.component';
import { PrivacyComponent } from '../privacy/privacy.component';
@Component({selector:'app-employee-legal', imports:[ModalShellComponent, PrivacyComponent, TranslatePipe],
  templateUrl:'./employee-legal.html', changeDetection:ChangeDetectionStrategy.OnPush})
export class EmployeeLegal {
  @Input() document: 'terms' | 'privacy' = 'terms';
  readonly modalController = inject(ModalController);
}
